interface TestimonialCardProps {
  name: string;
  text: string;
  avatar: string;
}

export function TestimonialCard({ name, text, avatar }: TestimonialCardProps) {
  return (
    <div className='flex items-center gap-4 bg-gray-50 rounded-lg'>
      <div className='flex-shrink-0'>
        <div className='w-12 h-12 bg-gray-300 rounded-full overflow-hidden'>
          <img
            src={avatar}
            alt={name}
            className='w-full h-full object-cover'
            onError={(e) => {
              const target = e.target as HTMLImageElement;

              target.style.display = 'none';
              target.parentElement!.innerHTML = `<div class="w-full h-full bg-gradient-to-br
               from-blue-400 to-purple-500 flex items-center justify-center
                text-white font-semibold text-lg">${name.charAt(0)}</div>`;
            }}
          />
        </div>
      </div>

      <div className='flex-1 min-w-0 space-y-2'>
        <h4 className='font-bold text-sm'>{name}</h4>
        <p className='text-xs'>{text}</p>
      </div>
    </div>
  );
}
